import React from 'react';
import { Dropdown, Input } from 'semantic-ui-react';
import {
  ParamsName,
  ParamsBlock,
  ParamsContent,
  ParamsColumn,
  ParamsTagsBlock,
  ParamsTagsName,
  ParamsTagsColumn,
  InfoBlock,
} from '../userPageStyles';
import { default_activity, default_gender } from '../../youslim2.0_Constants';
import ClientTagsBlock from '../../TagsBlock/ClientTagsBlock';

const genderOptions = [
  {
    key: 1,
    text: 'Женский',
    value: 'Женский',
  },
  {
    key: 2,
    text: 'Мужской',
    value: 'Мужской',
  },
];

const activityOptions = [
  { key: 1, text: 'Низкая или отсутствует', value: 'Низкая или отсутствует', coefficient: 1.2 },
  {
    key: 2,
    text: 'Невысокая активность (1-3 тренировки в неделю)',
    value: 'Невысокая активность (1-3 тренировки в неделю)',
    coefficient: 1.375,
  },
  {
    key: 3,
    text: 'Умеренная активность (4-5 тренировок в неделю)',
    value: 'Умеренная активность (4-5 тренировок в неделю)',
    coefficient: 1.55,
  },
  {
    key: 4,
    text: 'Высокая активность (6-7 тренировок в неделю)',
    value: 'Высокая активность (6-7 тренировок в неделю)',
    coefficient: 1.725,
  },
  {
    key: 5,
    text: 'Экстремально высокая активность (2 и более тренировок в день)',
    value: 'Экстремально высокая активность (2 и более тренировок в день)',
    coefficient: 1.9,
  },
];

const UserParamsBlock = React.memo(
  ({
    allProductsTags,
    choosedTags,
    setChoosedTags,
    params,
    currentGender,
    setCurrentGender,
    currentActivity,
    setCurrentActivity,
    currentHeight,
    setCurrentHeight,
    currentWeight,
    setCurrentWeight,
    currentAge,
    setCurrentAge,
    currentTargetWeight,
    setCurrentTargetWeight,
  }) => {
    return (
      <ParamsContent>
        <ParamsColumn>
          <ParamsBlock>
            <ParamsName>Пол</ParamsName>
            <Dropdown
              placeholder="Выберите пол"
              fluid
              selection
              options={genderOptions}
              defaultValue={default_gender[params.sex_id - 1]}
              value={currentGender}
              onChange={(e, data) => setCurrentGender(data.value)}
            />
          </ParamsBlock>
          <ParamsBlock>
            <ParamsName>Рост</ParamsName>
            <Input
              className="product-name-input"
              type="number"
              placeholder="Введите рос..."
              defaultValue={params.height}
              value={currentHeight}
              onChange={(e) => setCurrentHeight(e.target.value)}
            />
          </ParamsBlock>
          <ParamsBlock>
            <ParamsName>Текущий вес</ParamsName>
            <Input
              className="product-name-input"
              type="number"
              placeholder="Введите вес..."
              defaultValue={params.weight}
              value={currentWeight}
              onChange={(e) => setCurrentWeight(e.target.value)}
            />
          </ParamsBlock>
          <ParamsBlock>
            <ParamsName>Целевой вес</ParamsName>
            <Input
              className="product-name-input"
              type="number"
              placeholder="Введите целевой вес..."
              defaultValue={params.weight_target}
              value={currentTargetWeight}
              onChange={(e) => setCurrentTargetWeight(e.target.value)}
            />
          </ParamsBlock>
          <ParamsBlock>
            <ParamsName>Возраст</ParamsName>
            <Input
              className="product-name-input"
              type="number"
              placeholder="Введите возраст..."
              defaultValue={params.age}
              value={currentAge}
              onChange={(e) => setCurrentAge(e.target.value)}
            />
          </ParamsBlock>
          <ParamsBlock>
            <ParamsName>Активность</ParamsName>
            <Dropdown
              placeholder="Выберите активность"
              defaultValue={default_activity[params.activity_id - 1]}
              fluid
              selection
              options={activityOptions}
              value={currentActivity}
              onChange={(e, data) => setCurrentActivity(data.value)}
            />
          </ParamsBlock>
          <InfoBlock>*для создания пользователя все поля обьязательные для заполнения</InfoBlock>
        </ParamsColumn>
        <ParamsTagsColumn>
          <ParamsTagsBlock>
            <ParamsTagsName>Теги запрещённых продуктов</ParamsTagsName>

            <ClientTagsBlock
              allTags={allProductsTags}
              choosedTags={choosedTags}
              setChoosedTags={setChoosedTags}
              height="250px"
              flexBasis="7%"
              width="100%"
            />
          </ParamsTagsBlock>
        </ParamsTagsColumn>
      </ParamsContent>
    );
  },
);

export default UserParamsBlock;



// WEBPACK FOOTER //
// ./src/Components/YouSlim2.0/TestPage/UserParamsBlock/index.jsx